// Uebersetzt den technischen `error`-Code einer fehlgeschlagenen Proben-Umbenennung
// (siehe `shared/types.ts` AudioFailure) in einen Nutzertext. Lebt bewusst hier statt
// im Admin-Ordner: die oeffentliche Self-Service-Flaeche (Task 6) braucht dieselbe
// Funktion und darf kein Admin-CSS-Modul mitziehen.
export function failureReason(error: string): string {
  const m = /^webdav_move_failed_(\d+)$/.exec(error);
  if (m) return `Cloud-Fehler (Status ${m[1]})`;
  if (error === 'webdav_move_failed_network') return 'Cloud nicht erreichbar';
  if (error === 'filename_exists') return 'Zielname bereits vergeben';
  if (error === 'webdav_not_configured') return 'Cloud nicht konfiguriert';
  if (error === 'name_unbuildable') return 'Dateiname nicht bildbar (Sprachcode ohne Marker)';
  return error;
}
